import dayjs, { Dayjs } from "dayjs"
import calendar from "dayjs/plugin/calendar"

dayjs.extend(calendar)

export function formatRelativeDay(date: string | Date): string {
  return dayjs(date).calendar(null, {
    sameDay: "[Hoje]",
    lastDay: "[Ontem]",
    lastWeek: "DD/MM/YYYY",
    sameElse: "DD/MM/YYYY",
  })
}

export function formatFullDateTime(date: string | Date): string {
  return dayjs(date).format("DD/MM/YYYY HH:mm:ss")
}

export function formatTime(date: string | Date): string {
  return dayjs(date).format("HH:mm")
}

export function isDateInRange(date: string | Date, start: Dayjs | null, end: Dayjs | null): boolean {
  const target = dayjs(date)
  if (start && target.isBefore(start, 'day')) return false
  if (end && target.isAfter(end, 'day')) return false
  return true
}
